import { devices } from '@src/styles/theme';
import React from 'react';
import styled from 'styled-components';

type ButtonProps = {
  value?: string;
  borderRadius?: number;
  backgroundColor?: string;
  hoverColor?: string;
  children?: React.ReactNode;
  width?: number;
  height?: number;
  onClick: () => void;
  disabled?: boolean;
  style?: React.CSSProperties;
  borderColor?: string;
  color?: string;
};

const CMButton = ({
  disabled = false,
  width = 154,
  height = 52,
  value = 'Click',
  borderRadius = 5,
  backgroundColor,
  hoverColor,
  children,
  onClick = () => {},
  style,
  color = '#fff',
  borderColor,
}: ButtonProps) => {
  return (
    <Button
      disabled={disabled}
      width={width}
      height={height}
      value={value}
      borderRadius={borderRadius}
      backgroundColor={backgroundColor}
      hoverColor={hoverColor}
      name={value}
      onClick={onClick}
      style={style}
      color={color}
      borderColor={borderColor}
    >
      {children ? children : value}
    </Button>
  );
};

const Button = styled.button<{
  width: number;
  height: number;
  borderRadius: number;
  backgroundColor?: string;
  hoverColor?: string;
  disabled: boolean;
  borderColor?: string;
  color?: string;
}>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  font-weight: ${({ backgroundColor, theme }) =>
    backgroundColor ?? theme.commonColor.white};
  border-radius: ${({ borderRadius }) => borderRadius}px;
  border: 0;
  outline: 0;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  color: ${({ color }) => color};

  font-size: 20px;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  border: 1px solid
    ${({ borderColor, theme }) => borderColor ?? theme.commonColor.white};

  &:hover {
    cursor: pointer;
    background-color: ${({ hoverColor }) => hoverColor};
    color: ${({ theme }) => theme.commonColor.white};
  }
  @media ${devices.tablet} {
    width: 80px;
  }
`;
export default CMButton;
